// Maps a failed redeem POST to a page state.
// Backend answers: 401 auth_required (+ prefill_email), 400 "Already redeemed", 400 "Not payable/found", 400 expired window.
export function classifyRedeemError(err) {
  const status = err?.response?.status;
  const data = err?.response?.data;

  if (status === 401) return { kind: 'auth_required', email: data?.prefill_email || '' };

  if (status === 400) {
    const text = (typeof data === 'string' ? data : JSON.stringify(data ?? '')).toLowerCase();
    if (text.includes('already redeemed')) return { kind: 'already_redeemed' };
    if (text.includes('not payable')) return { kind: 'not_payable' };
    if (text.includes('expire')) return { kind: 'expired' };
  }

  return { kind: 'error' };
}
